export const CURRENCY_CODES = ['EUR', 'USD', 'BGN', 'GBP', 'CHF', 'RON', 'RUB', 'TRY', 'RSD', 'MKD', 'BTC'];